<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Gerente" subTitle="Editar" />

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small">
          <div class="card-header border-bottom">
            <h6 class="m-0">Informações do Gerente</h6>
          </div>
          <!-- Content -->
          <manager-form ref="managerForm" />
          <div class="card-body p-6 pb-3 text-left">
            <Assignment
              storeName="manager"
              entityName="Supervisores"
              :getAssociatedDistributors="getManagerSupervisors"
              :syncAttacherDistributors="syncAttacherManagerSupervisors"
            />
          </div>
        </d-card>
      </d-col>
      <d-col lg="3" md="12" class="mt-lg-0 mt-4">
        <sidebar-actions :model="supervisor" @save="save" />
      </d-col>
    </d-row>
    <manager-imports />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import Assignment from '_shared/Assignment.vue';
import PageHeader from '_shared/PageHeader.vue';
import ManagerForm from '../components/ManagerForm.vue';
import SidebarActions from '../components/SidebarActions.vue';
import ManagerImports from '../components/ManagerImports.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/ManagerModel';

export default {
  name: 'admin-manager-edit',
  components: {
    PageHeader,
    ManagerForm,
    Assignment,
    SidebarActions,
    ManagerImports,
  },
  computed: {
    supervisor() {
      const { manager } = this.$store.state.manager;
      if (manager) {
        return manager;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'checkAdmin',
      'getManager',
      'getManagerSupervisors',
      'syncAttacherManagerSupervisors',
    ]),
    getManagerModel(id) {
      this.getManager(id)
        .then(response => {
          Events.$emit(_LOAD_MODEL_, response);
        })
        .catch(error => {
          this.activeAlert({ message: error, theme: 'danger' });
        });
    },
    save() {
      this.$refs.managerForm.save();
    },
  },
  mounted() {
    this.checkAdmin();
    if (this.$route.params.id) {
      this.getManagerModel(parseInt(this.$route.params.id, Number));
    }
  },
};
</script>
